export const ALLERGEN_CHIPS = ["Peanuts", "Tree nuts", "Shellfish", "Fish", "Dairy", "Eggs", "Gluten / wheat", "Soy", "Sesame"];

export const ALLERGY_DISCLAIMER =
  "We prepare all food in a shared kitchen and cannot guarantee any dish is completely free of allergens. Please tell us about severe allergies by phone as well so we can advise you properly.";

export function allergySummaryText(flag, tags, note) {
  if (!flag) return null;
  const parts = [];
  if (tags && tags.length) parts.push(tags.join(", "));
  const t = (note || "").trim();
  if (t) parts.push(t);
  return parts.join(" — ") || null;
}
